export default "__VITE_ASSET__iTGsD5l___"